(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal:not([data-mt-r])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (e) { e.classList.add('mt-in'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('mt-in'); io.unobserve(x.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { e.setAttribute('data-mt-r', '1'); io.observe(e); });
  }

  function initGaleria() {
    document.querySelectorAll('[data-mt-gal]').forEach(function (g) {
      if (g.dataset.mtInit) return; g.dataset.mtInit = '1';
      var main = g.querySelector('[data-mt-main]');
      g.querySelectorAll('[data-mt-th]').forEach(function (b) {
        b.addEventListener('click', function () {
          main.src = b.getAttribute('data-src');
          main.removeAttribute('srcset');
          g.querySelectorAll('[data-mt-th]').forEach(function (x) { x.classList.remove('is-on'); });
          b.classList.add('is-on');
        });
      });
    });
  }

  function money(c) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2) + ' €'; }
  }

  function initProducto() {
    document.querySelectorAll('[data-mt-prod]').forEach(function (root) {
      if (root.dataset.mtInit) return; root.dataset.mtInit = '1';
      var data = JSON.parse(root.querySelector('[data-mt-json]').textContent);
      var form = root.querySelector('form');
      var idInput = form.querySelector('input[name=id]');
      var btn = form.querySelector('[data-mt-add]');
      var price = root.querySelector('[data-mt-price]');
      var cmp = root.querySelector('[data-mt-compare]');
      var main = root.querySelector('[data-mt-main]');
      function current() {
        var sel = [];
        root.querySelectorAll('[data-mt-opt]').forEach(function (fs) {
          var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
        });
        return data.variants.filter(function (v) { return sel.every(function (s, i) { return s === null || v.options[i] === s; }); })[0];
      }
      function update() {
        var v = current();
        if (!v) { btn.disabled = true; btn.textContent = data.t.noDisp; return; }
        idInput.value = v.id;
        if (price) price.textContent = money(v.price);
        if (cmp) { if (v.compare > v.price) { cmp.textContent = money(v.compare); cmp.hidden = false; } else { cmp.hidden = true; } }
        btn.disabled = !v.available;
        btn.textContent = v.available ? data.t.add : data.t.sold;
        if (v.image && main) { main.src = v.image; main.removeAttribute('srcset'); }
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      }
      root.querySelectorAll('[data-mt-opt] input').forEach(function (i) { i.addEventListener('change', update); });
    });
  }

  function initComparador() {
    document.querySelectorAll('[data-mt-ba]').forEach(function (el) {
      if (el.dataset.mtInit) return; el.dataset.mtInit = '1';
      var r = el.querySelector('input');
      function set() { el.style.setProperty('--mt-pos', r.value + '%'); }
      r.addEventListener('input', set); set();
    });
  }

  /* Banner de cookies de Shopify: texto más corto (mantiene el enlace a la política de privacidad). */
  function initCookieTexto() {
    var TXT = 'Cookies para anuncios y estadísticas, solo si aceptas. ';
    function fix() {
      var p = document.querySelector('.shopify-pc__banner__dialog p');
      if (!p || p.dataset.mtShort) return;
      var a = p.querySelector('a');
      if (!a) return;
      p.dataset.mtShort = '1';
      p.removeChild(a);
      p.textContent = TXT;
      p.appendChild(a);
      p.appendChild(document.createTextNode('.'));
    }
    fix();
    if (window.MutationObserver) {
      var n = 0, mo = new MutationObserver(function () { fix(); if (++n > 400) mo.disconnect(); });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 60000);
    }
  }

  function initTodo() { initReveal(); initGaleria(); initProducto(); initComparador(); }
  document.documentElement.classList.add('mt-js');
  initCookieTexto();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();